import React from 'react';

import ChartRenderer from 'common/charts/ChartRenderer';

type Props = {
  data: number[][];
  dataLabels: string[];
  labels: string[];
};

const MultiLineChart = ({ data, labels, dataLabels }: Props) => {
  const isValid =
    data.every((datum) => datum.length === labels.length) &&
    labels.length > 0 &&
    dataLabels.length === data.length;
  if (!isValid) {
    return null;
  }

  const chartConfig = getConfig(data, dataLabels, labels);

  return <ChartRenderer type="line" chartConfig={chartConfig} />;
};

export default React.memo(MultiLineChart);

function getConfig(data: number[][], dataLabels: string[], labels: string[]) {
  return {
    data: {
      labels,
      datasets: data.map((datum, index) => {
        return {
          clip: 1,
          data: datum,
          tension: 0.25,
          label: dataLabels[index],
        };
      }),
    },
    options: {
      aspectRatio: 3,
      responsive: true,
      maintainAspectRatio: false,
      layout: {
        autoPadding: false,
        padding: {
          left: 0,
          bottom: 1,
          right: 0,
          top: 2,
        },
      },
      scales: {
        y: {
          display: true,
          ticks: {
            maxTicksLimit: 8,
          },
        },
      },
      plugins: {
        tooltip: {
          enabled: true,
        },
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            pointStyle: 'rectRounded',
            usePointStyle: true,
            padding: 16,
          },
        },
      },
      elements: {
        point: {
          pointStyle: false,
        },
      },
    },
  };
}
